import React from "react";
import { TextComponent } from "../../../../../components";
import { FaFacebookSquare, FaInstagramSquare } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import { Col, Row } from "antd";
import instaIcon from "../../../../../assets/staticImages/instaIcon.png";
import styles from "./aboutUs.module.css";


function AboutUs() {
  return (
    <>
      <Row className={styles.aboutCont}>
        <TextComponent text={"About"} />
      </Row>
      <TextComponent
        textClass={styles.aboutText}
        text={
          "Leif Floyd Photography is a professional photography studio specializing in capturing stunning moments and memories. With a keen eye for detail and a passion for storytelling, Leif Floyd creates visually captivating images that reflect the essence"
        }
      />
    </>
  );
}

export default AboutUs;
